import { KalturaSeriesRecording } from '@kaltura-ott/ott-client-types';
import { KalturaRecording } from '@kaltura-ott/ott-client-types/api/types';

import { Record, KuxSeriesRecord, KuxRecord } from '../../interfaces/record';

export const getDaysBetweenTwoDate = (firstDate = new Date(), secondDate = new Date()): number => {
  const msInDay = 1000 * 3600 * 24;

  const diff = Math.floor(
    Date.UTC(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate()) -
      Date.UTC(secondDate.getFullYear(), secondDate.getMonth(), secondDate.getDate()),
  );

  const days = Math.round(diff / msInDay);
  return days;
};

export const normalizingRecord = (record: KalturaRecording | KuxRecord): Record => ({
  id: record.id,
  type: record.type,
  status: record.status,
  // @ts-expect-error TODO Fix
  isOngoing: record.viewableUntilDate <= 0,
  assetId: record.assetId,
  createDate: record.createDate,
  viewableUntilDate: record.viewableUntilDate,
  expiredInDays: record?.viewableUntilDate && getDaysBetweenTwoDate(new Date(record.viewableUntilDate * 1000)),
});

export const normalizingSeriesRecord = (seriesRecord: KalturaSeriesRecording): KuxSeriesRecord => ({
  id: seriesRecord.id,
  type: seriesRecord.type,
  epgId: seriesRecord.epgId,
  seriesId: seriesRecord.seriesId,
  channelId: seriesRecord.channelId,
  updateDate: seriesRecord.updateDate,
  createDate: seriesRecord.createDate,
});
